/**
 * footer-cc.js
 * Accordion logic for footer nav columns on mobile.
 *
 * Optimizations:
 *  - Single delegated click listener on the nav grid (not one per column)
 *  - Debounced resize handler
 *  - No jQuery / no external deps
 *  - Cleans up correctly when Shopify Theme Editor reloads the section
 */

(function () {
  'use strict';

  var resizeTimer = null;

  /**
   * Set all columns to desktop state (always open, no toggle interactivity).
   * @param {NodeList} cols
   */
  function setDesktop(cols) {
    cols.forEach(function (col) {
      var toggle = col.querySelector('.cc-footer-nav__toggle');
      var list   = col.querySelector('.cc-footer-nav__links');
      if (!toggle || !list) return;

      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('tabindex', '-1');
      list.classList.add('is-open');
      list.style.display = '';
    });
  }

  /**
   * Set all columns to mobile state (collapsed by default unless .is-open).
   * @param {NodeList} cols
   */
  function setMobile(cols) {
    cols.forEach(function (col) {
      var toggle = col.querySelector('.cc-footer-nav__toggle');
      var list   = col.querySelector('.cc-footer-nav__links');
      if (!toggle || !list) return;

      var isOpen = list.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.removeAttribute('tabindex');
      list.style.display = '';
    });
  }

  /**
   * Apply the correct state based on viewport width.
   */
  function applyState() {
    var grid = document.querySelector('.cc-footer-nav__grid');
    if (!grid) return;

    var cols    = grid.querySelectorAll('.cc-footer-nav__col');
    var isMobile = window.innerWidth <= 768;

    if (isMobile) {
      setMobile(cols);
    } else {
      setDesktop(cols);
    }
  }

  /**
   * Delegated click handler — one listener on the grid handles all toggles.
   */
  function onGridClick(e) {
    if (window.innerWidth > 768) return;

    var toggle = e.target.closest('.cc-footer-nav__toggle');
    if (!toggle) return;

    var col  = toggle.closest('.cc-footer-nav__col');
    var list = col && col.querySelector('.cc-footer-nav__links');
    if (!list) return;

    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    list.classList.toggle('is-open', !isExpanded);
  }

  /**
   * Boot: attach delegated listener and apply initial state.
   */
  function boot() {
    var grid = document.querySelector('.cc-footer-nav__grid');
    if (!grid) return;

    grid.addEventListener('click', onGridClick);
    applyState();
  }

  /**
   * Debounced resize: re-apply state when viewport crosses the 768px boundary.
   */
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyState, 120);
  });

  /* Boot on DOMContentLoaded or immediately if DOM is already ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify Theme Editor: re-init on section reload */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.cc-footer-nav__grid')) {
      boot();
    }
  });

})();